export function preventScroll() {
  const scrollY = document.documentElement.style.getPropertyValue("--scroll-y");
  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollY}`;
}

export function allowScroll() {
  const scrollY = document.body.style.top;
  document.body.style.position = "";
  document.body.style.top = "";
  window.scrollTo(0, Number.parseInt(scrollY || "0") * -1);
}
